import * as React from 'react';
import { SVGProps } from 'react';

const SvgBurgerIcon = (props: SVGProps) => {
  return (
    <svg
      width={24}
      height={18}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 6H1M23 1H1M23 11H1M23 16H1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SvgBurgerIcon;
